import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import UserCanConfirmBookingModal from '../user-can-confirm-booking-modal/UserCanConfirmBookingModal'
import { ClientProposalOutputDto } from '../../../../../../../lib/graphql'
import { errorToast } from '../../../../../../../utils'
import { IProposalInteractionsProps } from '../../../../Proposal'
import PingPongButton from '../../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../../utils/ping-pong-button-type.enum.ts'

const UserCanConfirmBookingFooter = ({
  userActions,
  clientProposal,
}: {
  userActions: IProposalInteractionsProps['userActions']
  clientProposal: Pick<
    ClientProposalOutputDto,
    '_id' | 'userCurrentAction' | 'clientRequestId'
  >
}) => {
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false)

  const userConfirmedBooking = userActions?.userConfirmedBooking

  if (!userConfirmedBooking) {
    return null
  }

  const onSubmit = async () => {
    try {
      await userConfirmedBooking.callback({
        clientProposalId: clientProposal._id,
      })
      setIsOpenConfirmModal(false)
    } catch {
      errorToast(["Impossible de demander l'approbation de l'administrateur"])
    }
  }

  return (
    <>
      <div className='flex w-full flex-col gap-3 py-5'>
        <PingPongButton
          dataTestId='book-this-stay-button'
          label={
            <FormattedMessage
              id='ui.userCurrentActionButton.canConfirmBooking'
              defaultMessage='Réserver ce séjour'
            />
          }
          type={PingPongButtonTypeEnum.CONFIRM}
          onClick={() => setIsOpenConfirmModal(true)}
        />
      </div>
      {isOpenConfirmModal && (
        <UserCanConfirmBookingModal
          clientRequestId={clientProposal.clientRequestId}
          closeModal={() => setIsOpenConfirmModal(false)}
          onSubmit={onSubmit}
          isLoadingSubmit={userConfirmedBooking.isLoading}
          isOpen={isOpenConfirmModal}
          selectedProposalId={clientProposal._id}
        />
      )}
    </>
  )
}

export default UserCanConfirmBookingFooter
